module.exports = __webpack_public_path__ + "img/brown-message.31c2a576.svg";